(function () {
  'use strict';

  /**
   * 
   * Buy A Swatch Button | LB 03.10.26
   * 
   * Reads a pre-built JSON lookup table (product variant ID →
   * swatch variant data) rendered by buy-buttons.liquid, then
   * wires up the swatch ATC form to react to Prestige's
   * variant:change event without any AJAX calls.
   * 
   * @see custom-buy-swatch.liquid
   */
  function initBuyASwatch() {
    var swatchDataEl = document.getElementById('lb-swatch-lookup-data');
    if (!swatchDataEl) return;

    var lookup;
    try {
      lookup = JSON.parse(swatchDataEl.textContent);
    } catch (e) {
      console.warn('[custom.js] Failed to parse swatch lookup data:', e);
      return;
    }

    var selectedSwatch = document.getElementById('lb-selected-swatch');
    var swatchBtn      = document.getElementById('lb-AddToCart-Buy-A-Swatch');
    var fallbackLink   = document.getElementById('lb-fallback-swatch-link');

    if (!selectedSwatch || !swatchBtn || !fallbackLink) return;

    function updateSwatchButton(variantId) {
      var data = lookup[String(variantId)];

      if (!data || !data.swatchVariantId) {
        swatchBtn.hidden    = true;
        fallbackLink.hidden = false;
        return;
      }

      if (!data.available) {
        swatchBtn.hidden    = true;
        fallbackLink.hidden = true;
        return;
      }

      selectedSwatch.value = data.swatchVariantId;
      swatchBtn.hidden     = false;
      fallbackLink.hidden  = true;
    }

    var initialVariantId = swatchDataEl.dataset.initialVariantId;
    if (initialVariantId) {
      updateSwatchButton(initialVariantId);
    }

    document.addEventListener('variant:change', function (event) {
      var detail = event.detail;
      if (!detail || !detail.variant) return;
      updateSwatchButton(detail.variant.id);
    });
  }

  /**
   *
   * Dynamic ATC Button | LB 03.25.26
   *
   * When a shopper selects a quantity that exceeds the current
   * variant's inventory, the Add to Cart button text changes to a
   * custom message with a lead-time appropriate to the product's
   * collection type. The stock badge is hidden at the same time.
   * Both are restored when the quantity drops back <= inventory.
   *
   * Custom messaging and product types are determined server-side and
   * embedded as JSON by custom-inventory-data.liquid.
   *
   * @see snippets/custom-inventory-data.liquid
   */
  function initDynamicATC() {
    const dataEl = document.getElementById('lb-inventory-lookup');
    if (!dataEl) return;

    const MADE_TO_ORDER_TEXT = 'Made to Order'
    const IN_STOCK_TEXT = 'In Stock'
    const NO_COLORWAY_FLAG = '__no_colorway__'

    let data, btn, defaultBtnText, defaultBtnColor, variantInv, qtyInput, availabilityInputs
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('[custom.js] Failed to parse dynamic ATC data:', e);
      return;
    }

    const formId      = dataEl.dataset.formId;
    const productType = dataEl.dataset.productType;
    let currentVariant = data[String(dataEl.dataset.initialVariantId)];
    if (!currentVariant) return;

    // LB Developer 04.03.26 | Availability Switch
    // -----------------------------------------------------------
    // Build a colorway → { inStockId, madeToOrderId, quantity } map
    // from the existing inventory JSON so we can auto-select the
    // correct Availability variant without any extra network calls.
    // This will only map on products that have an availability option.
    const availPos    = dataEl.dataset.availabilityOptionPosition;
    const colorwayPos = availPos === '1' ? '2' : '1';
    const colorwayMap = {};

    if (availPos) {
      for (const [id, v] of Object.entries(data)) {
        const colorway     = v['option' + colorwayPos] || NO_COLORWAY_FLAG;
        const availability = v['option' + availPos];
        if (!colorwayMap[colorway]) colorwayMap[colorway] = {};
        const availabilityLower = availability ? availability.toLowerCase() : '';
        if (availabilityLower === IN_STOCK_TEXT.toLowerCase()) {
          colorwayMap[colorway].inStockId = id;
          colorwayMap[colorway].quantity  = v.quantity;
        } else if (availabilityLower === MADE_TO_ORDER_TEXT.toLowerCase()) {
          colorwayMap[colorway].madeToOrderId = id;
        }
      }
    }

    getDOM();
    evaluate();

    /**
     * Quantity stepper changes bubble to the document. Listening here
     * rather than on qtyInput directly so the handler survives variant
     * rerenders, which replace the qtyInput element in the DOM.
    */
    document.addEventListener('change', function (event) {
      if (event.target.getAttribute('form') !== formId) return;
      if (event.target.name !== 'quantity') return;
      evaluate();
    });

    /**
     * After a variant switch the theme does a partial DOM rerender,
     * then fires variant:change. Update currentVariant from the JSON
     * data and re-evaluate against the current quantity.
    */
    document.addEventListener('variant:change', function (event) {
      const detail = event.detail;
      if (!detail || !detail.variant) return;
      currentVariant = data[String(detail.variant.id)];
      
      setTimeout(function () {
        getDOM();
        evaluate();
      }, 0);
    });

    function getDOM() {
      btn = document.querySelector('#' + formId + ' buy-buttons [type="submit"]');
      defaultBtnText = btn.textContent.trim();
      defaultBtnColor = getComputedStyle(btn).getPropertyValue('--button-background')
      variantInv = document.querySelector('product-rerender[observe-form="' + formId + '"] variant-inventory');
      qtyInput   = document.querySelector('quantity-input input[form="' + formId + '"]');

      // CUSTOM LB 04.03.26 — Re-hide Availability fieldset and rebuild input map
      // after each DOM rerender (product-rerender replaces the variant picker HTML
      // on every variant:change, resetting hidden and invalidating cached inputs).
      if (availPos) {
        const availabilityFieldset = document.querySelector(
          '.variant-picker__option:has(input[data-option-position="' + availPos + '"][form="' + formId + '"])'
        );
        if (availabilityFieldset) availabilityFieldset.hidden = true;

        availabilityInputs = Array.from(
          document.querySelectorAll('input[data-option-position="' + availPos + '"][form="' + formId + '"]')
        ).map(function (input) {
          return { input: input, label: input.labels[0].textContent.trim().toLowerCase() };
        });
      }
    }

    function evaluate() {
      switchAvailability();

      // For non-textile products (e.g. pillows) there is no Availability option,
      // so the original qty-vs-inventory check drives button text instead.
      if (availPos) return;

      if (!currentVariant.management) return;
      if (!btn || !qtyInput) return;

      const qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty)) return;

      if (qty > currentVariant.quantity) {
        btn.textContent = currentVariant.button_text || MADE_TO_ORDER_TEXT;
        btn.disabled = currentVariant.button_disable || false
        if (btn.disabled) {
          btn.style.setProperty('--button-background', '178 178 178') // must be in rgb - necessary to override inline style set by Prestige
        }
        if (variantInv) variantInv.hidden = true;
      } else {
        btn.textContent = defaultBtnText;
        btn.style.setProperty('--button-background', defaultBtnColor)
        btn.disabled = false
        if (variantInv) variantInv.hidden = false;
      }
    }

    // LB Developer 04.03.26 | Availability Switch
    // -----------------------------------------------------------
    // Selects "In Stock" or "Made To Order" variant automatically.
    // Called at the top of evaluate() so it runs on both quantity
    // changes and colorway (variant:change) changes.
    function switchAvailability() {
      if (!availPos || !qtyInput || !availabilityInputs) return;

      const colorwayName = currentVariant['option' + colorwayPos] || '__no_colorway__';

      const entry = colorwayMap[colorwayName];
      if (!entry) return;

      const qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty)) return;

      const isMTO = !entry.inStockId || qty > entry.quantity;
      const targetLabel = isMTO ? MADE_TO_ORDER_TEXT.toLowerCase() : IN_STOCK_TEXT.toLowerCase();
      const target = availabilityInputs.find(function (item) { return item.label === targetLabel; });
      if (!target) return;

      // Update button text regardless of whether the radio is already checked,
      // since getDOM() resets defaultBtnText from the DOM after each rerender.
      if (btn) {
        btn.textContent = isMTO ? (currentVariant.button_text || MADE_TO_ORDER_TEXT) : defaultBtnText;
        if (variantInv) variantInv.hidden = isMTO;
      }

      if (target.input.checked) return;
      target.input.checked = true;
      target.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /**
   *
   * Retail/Trade Login | LB 03.12.26
   * 
   * Updates Login page content when switching between a Retail user
   * and a Trade Partner. Specifically the language and URL for
   * the "signup" link.
   * 
   * @see custom-main-customers-login.liquid
   */
  function initRetailTradeLogin() {
    const dataEl = document.getElementById('lb-account-type-data');
    if (!dataEl) return;
    
    let accountType = {}
    const data = JSON.parse(dataEl.textContent);
    const loginFields = document.getElementById('lb-login-fields')
    const noAccount = document.getElementById('lb-login-no-account')
    const registerLink = document.getElementById('lb-register-link')
    const title = document.getElementById('lb-login-title')

    document.querySelector('select[name="account_type"]')?.addEventListener('change', ev => {
      const isFirstReveal = loginFields.hasAttribute('hidden')
      accountType = data[ev.target.value]
      updateDOM()
      loginFields.removeAttribute('hidden')
      if (isFirstReveal) title.focus()
    })

    function updateDOM() {
      title.textContent = accountType.title
      noAccount.innerHTML = accountType.no_account_text
      registerLink.href = accountType.register_link_url
      registerLink.textContent = accountType.register_link_text
    }
  }

  /**
   *
   * Gallery <-> Variant Picker Sync | LB 03.26.26
   *
   * Prestige will change the gallery image to whatever the selected
   * variant is. This function does the reverse: when the user swipes
   * the gallery, the variant picker updates to the variant if there is
   * a media that matches.
   *
   * @see snippets/custom-gallery-sync-data.liquid
   */
  function initGallerySync() {
    const dataEl = document.getElementById('lb-gallery-sync-data');
    if (!dataEl) return;

    const mediaToVariant = JSON.parse(dataEl.textContent);
    const formId = dataEl.dataset.formId;
    const gallery = document.querySelector('product-gallery');
    const carousel = gallery.querySelector('scroll-carousel');
    if (!gallery || !carousel) return;

    let isSyncingFromVariant = false;

    // this ensures we don't get caught in a loop between variant:change and carousel:settle
    document.addEventListener('variant:change', function (event) {
      if (!event.detail || event.detail.formId !== formId) return;
      if (!event.detail.variant || !event.detail.variant.featured_media) return;
      isSyncingFromVariant = true;
      setTimeout(function () { isSyncingFromVariant = false; }, 500);
    });

    // When the gallery settles on a new slide, update the variant picker.
    carousel.addEventListener('carousel:settle', function (event) {
      if (isSyncingFromVariant) return; // bail early if we are in the niddle of a sync from the variant picker
      const mediaId = event.detail.cell && event.detail.cell.dataset.mediaId;
      if (!mediaId) return;

      const match = mediaToVariant[mediaId];
      if (!match) return;
            
      const targetValue = match.options[0];
      
      // Variant picker uses radios under the hood when selecting from the "dropdown" UI
      const radioInputs = document.querySelectorAll(
        'input[type="radio"][data-option-position="1"][form="' + formId + '"]'
      );
      let matched = false;
      for (const input of radioInputs) {
        const label = document.querySelector('label[for="' + input.id + '"]');
        if (label && label.textContent.trim() === targetValue && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          matched = true;
          break;
        }
      }

    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initBuyASwatch();
    initRetailTradeLogin();
    initDynamicATC();
    initGallerySync();
  });

})();
